import React from 'react';
import styled from '@emotion/styled';
import {
	ArrowLink,
	StyledIconLink,
	StyledLinkText,
	VisuallyHidden,
} from '../../../../../../ui';
import { Column, ColumnHeader } from './Column';
import { ITypeProps, StyledType, Type } from './Type';
import { withTranslate } from '../../../../../shared/i18n/translate';
import Responsive from '../../../../../../ui/utils/Responsive';

interface IProps extends ITypeProps {
	href: string;
	screenReaderText: string;
	role?: 'columnheader' | 'cell';
}

export const StyledDetailsLinkColumn = styled(
	({ role = 'columnheader', ...props }) =>
		role === 'columnheader' ? (
			<ColumnHeader {...props} />
		) : (
			<Column {...props} />
		),
)`
	max-width: 120px;
	text-align: right;
	padding-right: 0;

	${StyledType} {
		display: none;

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			display: block;
		}
	}

	${StyledIconLink} {
		white-space: nowrap;

		${StyledLinkText} {
			text-overflow: initial;
			overflow: initial;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 65px;
		font-size: 14px;

		${StyledType} {
			font-size: 14px;
		}

		svg {
			width: 18px;
		}
	}
`;

export const DetailsLinkColumn = withTranslate<IProps>(
	({ t, href, arrival, screenReaderText, role }) => (
		<StyledDetailsLinkColumn role={role}>
			<Type arrival={arrival} />
			<ArrowLink href={href}>
				{t('flight_list_details_link')}
				<VisuallyHidden>{screenReaderText}</VisuallyHidden>
			</ArrowLink>
		</StyledDetailsLinkColumn>
	),
);
